import React, { useEffect } from 'react';
import './App.css';
import { Box } from '@mui/material';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { flatten } from 'lodash';
import { toast } from 'material-react-toastify';
import { selectedPageAtom } from './atoms/Page';
import { isTokenValid } from './utils/Auth';
import { LoginPage } from './pages/Login/LoginPage';
import { pageCategories } from './variables/PageCategory';
import { BaseLayout } from './components/Layout/BaseLayout';
import { PrintShipmentPage } from './pages/PrintShipment/PrintShipmentPage';
import { PrintOrdersPage } from './pages/PrintOrders/PrintOrdersPage';
import { frontendSettingsAtom } from './atoms/FrontendSettings';
import { getFrontendSettings } from './api/Settings';

const App = () => {
  const navigate = useNavigate();

  const setFrontendSettings = useSetRecoilState(frontendSettingsAtom);
  const selectedPage = useRecoilValue(selectedPageAtom);

  const loggedIn = isTokenValid();

  useEffect(() => {
    getFrontendSettings()
      .then(setFrontendSettings)
      .catch((err) => toast.error(err.message));
  }, []);

  useEffect(() => {
    if (!loggedIn) {
      navigate('/login');
    }
  }, [selectedPage]);

  return (
    <Box>
      <Routes>
        <Route path='/login' element={<LoginPage />} />
        {flatten(
          pageCategories.map((category) =>
            category.pages.map((page) => (
              <Route
                path={`/${category.path}/${page.path}*`}
                key={page.name}
                element={<BaseLayout page={page} />}
              />
            )),
          ),
        )}
        <Route
          path='/print-shipment/:orderIDs'
          element={<PrintShipmentPage />}
        />
        <Route path='/print-orders/:orderIDs' element={<PrintOrdersPage />} />
        <Route
          path='*'
          element={
            <Navigate
              to={`/${pageCategories[0].path}/${pageCategories[0].pages[0].path}`}
            />
          }
        />
      </Routes>
    </Box>
  );
};

export default App;
